import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';

const SiAxios = React.forwardRef(function SiAxios2({ title = "Axios", color = "currentColor", size = 24, ...others }, ref) {
  if (color === "default") {
    color = "#5A29E4";
  }
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      ref,
      ...others,
      children: [
        /* @__PURE__ */ jsx("title", { children: title }),
        /* @__PURE__ */ jsx("path", { d: "M11.0683 2.89968V22.2973l-2.11399 1.70265V7.8638H4.975l6.0933-4.96412zM14.93426 0v15.76724H19.025l-6.20044 5.08865V1.4689L14.93426 0z" })
      ]
    }
  );
});
const SiAxios$1 = SiAxios;

export { SiAxios$1 as default };
